
import Profile from "pages/common/Profile.js";
import Settings from "pages/common/Settings.js";
import ViewProfile from "pages/common/ViewProfile.js";
import Overview from "pages/info/Overview.js";
import Messaging from "pages/superadmin/Messaging.js";
import PreEvents from "pages/superadmin/PreEvents.js";
import AddEvent from "pages/superadmin/AddEvent.js";
import EditEvent from "pages/superadmin/EditEvent.js";
import AddPoster from "pages/superadmin/AddPoster.js";
import About from "pages/info/About.js";

var routes = [
    // working
    {
        path: "/overview",
        name: "Overview",
        icon: "ni ni-tv-2 text-",
        component: Overview,
        layout: "/info",
    },
    // working
    {
        path: "/about",
        name: "About",
        icon: "ni ni-single-copy-04 text-",
        component: About,
        layout: "/info",
    },
    // working
    {
        path: "/add-event",
        name: "Add Event",
        icon: "ni ni-fat-add text-",
        component: AddEvent,
        layout: "/info",
    },
    // working
    {
        path: "/edit-event",
        name: "Edit Event",
        icon: "ni ni-fat-add text-",
        component: EditEvent,
        layout: "/info",
    },
    // working
    {
        path: "/add-poster",
        name: "Add Poster",
        icon: "ni ni-fat-add text-",
        component: AddPoster,
        layout: "/info",
    },
    // working
    {
        path: "/messaging",
        name: "Messaging",
        icon: "ni ni-email-83 text-",
        component: Messaging,
        layout: "/info",
    },
    {
        path: "/pre-events",
        name: "Pre Events",
        icon: "ni ni-ungroup text-fdvd",
        component: PreEvents,
        layout: "/info",
    },
    // working
    // {
    //     path: "/groups",
    //     name: "Groups",
    //     icon: "ni ni-circle-08 text-fdvd",
    //     component: Accounts,
    //     layout: "/info",
    // },
    {
        path: "/settings",
        name: "Settings",
        icon: "ni ni-bullet-list-67 text-dark",
        component: Settings,
        layout: "/info",
    },
    // Hidden
    // Hidden
    // Hidden
    // Hidden
    // Hidden
    // Hidden
    // working
    {
        path: "/user-profile",
        name: "User Profile",
        icon: "ni ni-single-02 text-yellow",
        component: Profile,
        layout: "/info",
    },
    // working
    {
        path: "/view-profile=:id",
        name: "View Profile",
        icon: "ni ni-single-02 text-yellow",
        component: ViewProfile,
        layout: "/info",
    },
    // working
    // {
    //     path: "/view-commission",
    //     name: "View Commission",
    //     icon: "ni ni-single-02 text-yellow",
    //     component: Commission,
    //     layout: "/info",
    // },
    // // working
    // {
    //     path: "/view-negotiation",
    //     name: "View Negotiation",
    //     icon: "ni ni-single-02 text-yellow",
    //     component: Negotiation,
    //     layout: "/info",
    // },
    // // working
    // {
    //     path: "/view-contracts",
    //     name: "View Contracts",
    //     icon: "ni ni-single-02 text-yellow",
    //     component: UserContracts,
    //     layout: "/info",
    // },
    // // working
    // {
    //     path: "/edit-contract",
    //     name: "Edit Contract",
    //     icon: "ni ni-single-02 text-yellow",
    //     component: EditContract,
    //     layout: "/info",
    // },
    // // working
    // {
    //     path: "/edit-account",
    //     name: "Edit Account",
    //     icon: "ni ni-single-02 text-yellow",
    //     component: EditAccount,
    //     layout: "/info",
    // },
    // // working
    // {
    //     path: "/view-biddings",
    //     name: "View Bidding",
    //     icon: "ni ni-single-02 text-yellow",
    //     component: Bidding,
    //     layout: "/info",
    // },
    // {
    //     path: "/tables",
    //     name: "Tables",
    //     icon: "ni ni-bullet-list-67 text-red",
    //     component: Tables,
    //     layout: "/info",
    // },
];
export default routes;
